import script from "./MonthRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthRangePicker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__